import SubpageLayout from "@/components/SubpageLayout";
import { SeedOrnament } from "@/components/Dandelion";

const Section = ({ title, children }) => (
  <section className="mt-16 first:mt-0">
    <h2 className="font-serif text-2xl text-[#3F5A47] sm:text-3xl">{title}</h2>
    <div className="mt-6 space-y-6">{children}</div>
  </section>
);

const P = ({ children }) => (
  <p className="text-base leading-loose text-[#2F3338]/85">{children}</p>
);

const Emphasis = ({ children }) => (
  <p className="border-l-2 border-[#B46A45]/60 py-1 pl-6 font-serif text-xl leading-relaxed text-[#3F5A47] sm:text-2xl">
    {children}
  </p>
);

const VoresTilgang = () => (
  <SubpageLayout overline="TRAUMEBEVIDST UDVIKLING" title="Vores tilgang" art="/brand/phase-spredning.png" testId="page-vores-tilgang">
    <Section title="Traumebevidst Udvikling">
      <P>
        Navnet Traumebevidst Udvikling afspejler en grundlæggende faglig overbevisning om, at
        traumer og udvikling ikke er modsætninger. En traumebevidst tilgang handler ikke om at
        definere mennesker ud fra deres traumer, men om at forstå reaktioner i sammenhæng med det
        liv, et menneske lever og har levet. I denne forståelse findes også ressourcer, mening,
        håb, styrke, modstandskraft og muligheder for udvikling.
      </P>
      <Emphasis>
        Udvikling er målet. Traumebevidsthed er et fundament for at komme derhen.
      </Emphasis>
    </Section>

    <Section title="Udvikling på tværs">
      <P>
        Vores arbejde med udvikling går på tværs af niveauer. Fra individet til grupper,
        fællesskaber, organisationer og samfund. Både mistrivsel og udvikling formes i et komplekst
        samspil mellem krop, psyke, sociale forhold, livshistorie og de systemer, vi er en del af.
      </P>
      <P>
        Derfor arbejder vi både med specialiseret viden om traumer og med de relationelle, faglige
        og organisatoriske betingelser, som mennesker lever og arbejder under. På tværs af disse
        niveauer er vi optagede af at skabe betingelser, der understøtter sikkerhed, handlekraft og
        forbindelse.
      </P>
    </Section>

    <Section title="Reaktioner og forståelser gør en forskel">
      <P>
        Det, der udefra kan fremstå uhensigtsmæssigt, uforståeligt eller problematisk, kan give
        mere mening, når vi forstår det i sammenhæng med menneskets erfaringer. Nogle reaktioner
        kan samtidig være måder at beskytte sig selv eller mestre noget svært på. Når vi bliver
        nysgerrige på sammenhængen, kan der åbnes for andre forståelser, ressourcer og nye
        handlemuligheder.
      </P>
      <P>
        Den måde, vi forstår menneskers reaktioner på, har betydning for den måde, vi møder dem på.
        Sprog, faglige forståelsesrammer og fortællinger kan fastholde mennesker i bestemte
        positioner – men de kan også åbne for håb og udvikling.
      </P>
    </Section>

    <Section title="Også gode intentioner kan få utilsigtede konsekvenser">
      <P>
        Gode intentioner er ikke i sig selv en garanti for, at vores indsatser og praksisser ikke
        kan gøre skade. Måden, vi forstår, organiserer og handler på, kan utilsigtet skabe
        yderligere belastning eller genaktivere tidligere erfaringer med utryghed, afmagt og tab af
        kontrol. I en traumebevidst tilgang retter vi derfor også fokus på os selv og de
        betingelser, vi er med til at skabe. Vi må forholde os til vores rammer, positioner,
        relationer, sprog og praksisser for at understøtte trivsel og faglig kvalitet og mindske
        risikoen for utilsigtet skade og retraumatisering.
      </P>
    </Section>

    <Section title="Fra forståelse til udvikling">
      <P>
        Vi skal ikke kun blive bedre til at hjælpe mennesker med at passe ind i de rammer, vi
        allerede har skabt. Vi må også være villige til at undersøge og udvikle rammerne. Og vi
        skal ikke kun hjælpe fagpersoner med at holde til belastende arbejdsmiljøer. Vi skal også
        arbejde for at skabe mere bæredygtige arbejdspladser med bedre trivsel, mindre belastning
        og sygefravær og bedre muligheder for at fastholde medarbejdere og faglig kvalitet.
      </P>
      <P>
        Traumebevidst udvikling handler derfor både om mennesker og om de relationer,
        arbejdspladser, organisationer og systemer, vi er en del af. Om at skabe bedre betingelser
        for det, der kan blive muligt.
      </P>
    </Section>

    <SeedOrnament className="mx-auto mt-20 w-14" />
  </SubpageLayout>
);

export default VoresTilgang;
